
 <template>
  <div class='AchievementRecord'>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" :offset=10 @load="loadList">
        <ul class="scrollList">
          <li v-for="(item, index) in pageList" :key='index'>
            <div class="box-body van-hairline--bottom">
              <h3 v-cloak>{{item.AchievementRecordName}}</h3>
              <div class="list-body-box">
                <span v-cloak>{{item.AchievementRecordExamTypeName}}</span>
                <span v-cloak>{{item.YearGradeName}}</span>
              </div>
              <div class="list-body-box">
                <span v-cloak>{{item.TimeName}}</span>
                <span v-cloak>{{item.IsPublishedName}}</span>
              </div>
            </div>
            <div class="box-footer">
              <div>
                <van-switch v-model="item.IsPublished" size="24px" active-color="rgb(76, 216, 100)" @input="switchTog(item.IsPublished,item.AchievementRecordID)" />
              </div>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
 
 <script>
import { Notify } from "vant"
export default {
  name: "AchievementRecord",
  components: {},
  data () {
    return {
      page: 1,
      pageSize:8,
      pageList: [],
      finished: false,
      loading: false,
      isLoading: false
    };
  },
  computed: {
    apipath () {
      return this.$store.state.apiPath
    }
  },
  created: function () {
    // 加载数据列表
    this.loadList();
  },
  methods: {
    loadList () {
      this.xy.loading()
      let that = this;
      let obj = {
        pageIndex: that.page,
        pageSize: that.pageSize,
        schoolDistrictId: 0,
        academicYearId: 0,
        academicSessionId: 0
      };
      let ulr = `${this.apipath}/api/AchievementRecord/GetPage`
      this.xyapi.get(ulr, obj).then(res => {
        let list = res.data.data
        that.pageList = [...that.pageList, ...list]
        that.loading = false
        this.xy.unloading()
        that.page++;
        that.finished = (that.pageList.length >= res.data.totalRecords) ? true : false;

      });
    },
    onRefresh () {
      setTimeout(() => {
        this.pageList = []
        this.page = 1
        this.isLoading = false
        this.loadList()
      }, 500)
    },
    async switchTog (status, id) {
      let action = "/api/AchievementRecord/PublishStatusChange";
      let res = await this.xyapi.post(`${this.apipath}${action}`, { status, AchievementRecordID:id })
      if (res.success) {
        Notify({ type: "success", message: '修改成功' })
        this.onRefresh()
      } else {
        Notify({ type: "danger", message: res.msg })
      }
    }
  }
};
</script>
 <style lang='less' scoped>
.scrollList {
    padding: 15px;
  li {
    background: #fff;
    padding: 15px;
    margin-bottom: 25px;
    .box-body {
      border-bottom: 1px solid #eee;
      padding: 12px 10px;
      h3 {
        margin-bottom: 12px;
        font-size: 28px;
        color: #333;
      }
      .list-body-box {
        margin-bottom: 10px;
        span{
          margin-right: 10px;
        }
      }
    }
    .box-footer {
      padding: 10px;
    }
  }
}
</style>